import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { sxDarkGreyBody, sxSubTitle } from "../../../../../assets/styles/CommonSxProps";
import { sxButton, sxOutlinedButton } from "../sxProps";
import './styles.css';
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";

const ProtocolShow: React.FC<{ protocolo: string, handleNewRefund: () => void }> = ({ protocolo, handleNewRefund }) => {

  const navigate = useNavigate();
  const { contrastMode } = useAccessibility()

  return (
    <div className="feature-container">
      <Box maxWidth={'600px'} display={'flex'} flexDirection={'column'} gap={'15px'}>
        <Typography fontSize={'24px'} sx={sxSubTitle} component="h2" style={{color: contrastMode ? '#fff' : ''}}>Pronto!</Typography>
        <Typography sx={sxDarkGreyBody} style={{color: contrastMode ? '#fff' : ''}}>Seu reembolso foi solicitado com sucesso e agora está em análise.</Typography>
        <Typography sx={sxDarkGreyBody} style={{color: contrastMode ? '#fff' : ''}}><b>Protocolo: </b> {protocolo}</Typography>
        <Typography sx={sxDarkGreyBody} style={{color: contrastMode ? '#fff' : ''}}>
          O número deste protocolo foi enviado para o seu e-mail 
          e o status da sua solicitação pode ser consultado a qualquer momento em "Meus reembolsos".
        </Typography>
        <div className="account-modal-buttons">
          <div className="account-modal-button">
            <Button
              variant="outlined"
              onClick={() => navigate('/financeiro/reembolso/meusReembolsos')}
              sx={{...sxOutlinedButton, color: contrastMode ? '#fff' : '#00995D'}}
              fullWidth>
              MEUS REEMBOLSOS
            </Button>
          </div>
          <div className="account-modal-button">
            <Button
              variant="contained"
              sx={sxButton}
              onClick={handleNewRefund}
              fullWidth>
              SOLICITAR NOVO REEMBOLSO
            </Button>
          </div>
        </div>
      </Box>
    </div >
  )
}

export default ProtocolShow;